const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/agentic-insights/experimental/briefing-1.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/common/translations/i18n';
import { experimentalSearchSchema } from '@/features/agentic-insights/components/experimental/briefing-1/data/searchState';
import { agenticInsightsBeforeLoad } from '../index';

/**
 * Briefing #1 — the first variant, frozen at the reading feedback was given on. It keeps its own URL
 * so it can be opened beside a later variant and the two judged as designs.
 */
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/agentic-insights/experimental/briefing-1')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: agenticInsightsBeforeLoad,
  validateSearch: search => experimentalSearchSchema.parse(search),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.agenticInsights.title)
    }
  }
});